/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 项目提醒
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  productId: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.ProductRemindDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/product/remind/${productId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
